import * as actions from "../actions/actions";

const message = (state = {}, action) => {
  switch (action.type) {
    case actions.SET_MESSAGE:
      return Object.assign({}, state, { [action.id]: action.text });
    case actions.SET_LOGOUT:
      return Object.assign({}, state, {
        logout: {
          url: action.url,
          stage: action.stage,
          text: action.text,
          okText: action.okText,
          cancelText: action.cancelText,
          topImg: action.topImg,
          sessionExpired: action.sessionExpired,
        },
      });
    default:
      return state;
  }
};

const app = (state = {}, action) => {
  switch (action.type) {
    case actions.OPEN_MENU:
      return Object.assign({}, state, { isMenuOpen: action.isMenuOpen });
    case actions.SET_STAGE:
      return Object.assign({}, state, { stage: action.stage });
    case actions.SET_SOURCE:
      return Object.assign({}, state, { source: action.source });
    case actions.SET_FOCUS:
      return Object.assign({}, state, { focusOn: action.refName });
    case actions.SET_LOADER:
      return Object.assign({}, state, { isLoading: action.isLoading });
    case actions.SET_ERROR:
      let error =
        action.code || action.text
          ? { code: action.code, text: action.text }
          : null;
      return Object.assign({}, state, { error: error });
    case actions.SET_IS_CONNECTED:
      return Object.assign({}, state, { isConnected: action.isConnected });
    case actions.SET_MESSAGE:
    case actions.SET_LOGOUT:
      return Object.assign({}, state, {
        message: message(state.message, action),
      });
    case actions.CALL_GA:
      return Object.assign({}, state, {
        ga: { page: action.page, error: action.error },
      });
    case actions.CALL_GA_EVENT:
      return Object.assign({}, state, {
        ga: {
          category: action.category,
          action: action.action,
          label: action.label,
        },
      });
    case actions.SET_IS_CAL_PROVIDER:
      return Object.assign({}, state, { isCalProvider: action.isCalProvider });
    default:
      return state;
  }
};

export default app;



// WEBPACK FOOTER //
// ./src/reducers/app.js